(function($) {
    $(() => {
		var scrollPos = 0;

        $('.js-show-avatar').click(function(){
        	var id = $(this).data('avatar-id');
            $('.icon-tile--avatar-' + id).addClass('is-shown');

            if ($(window).width() < 768){
                scrollPos = $(window).scrollTop();
                $('body').css({
                    overflow: 'hidden',
                    position: 'fixed',
                    width: '100vw',
                    top : -scrollPos
                });
            }
        });
        
        $('.js-close-avatar').click(function(){
            $(this).parents('.icon-tile').removeClass('is-shown');
            $('body').css({
                overflow: '',
                position: 'relative',
                top: ''
            });
            $(window).scrollTop(scrollPos);
        });
        
    });
})(jQuery);
